import { ReebeloStoreT } from '@lambda/reebelo';
import i18n from '@/settings/i18n';
import { CategoryOptionT } from './types';

const t = i18n.init('homepage');

const getOptions = () => {
  const home: CategoryOptionT = {
    value: 'home',
    title: t`Home`,
    categoryPk: '02n5t7v7l3p4',
  };

  const gaming: CategoryOptionT = {
    value: 'gaming',
    title: t`Gaming`,
    categoryPk: '05m6w134l0u2',
  };

  const designerBags: CategoryOptionT = {
    value: 'designer-bags',
    title: t`Designer Bags`,
    categoryPk: '1270p1r5j7q1',
  };

  const sports: CategoryOptionT = {
    value: 'sports',
    title: t`Sports`,
    categoryPk: '02h610t3d134',
  };

  const tools: CategoryOptionT = {
    value: 'tools',
    title: t`Tools`,
    categoryPk: '02n5r6d70612',
  };

  const fashion: CategoryOptionT = {
    value: 'fashion',
    title: t`Fashion`,
    categoryPk: '1263a5e4b474',
  };

  const audio: CategoryOptionT = {
    value: 'audio',
    title: t`Audio`,
    categoryPk: '02h610t3d250',
  };

  const cameras: CategoryOptionT = {
    value: 'cameras',
    title: t`Cameras`,
    categoryPk: '05t36596t4f0',
  };

  const hairCare: CategoryOptionT = {
    value: 'hair-care',
    title: t`Hair Care`,
    categoryPk: '02h610t3d230',
  };

  const tabletAccessories: CategoryOptionT = {
    value: 'tablet-accessories',
    title: t`Tablet Accessories`,
    categoryPk: '05t3a34726r0',
  };

  const phoneAccessories: CategoryOptionT = {
    value: 'phone-accessories',
    title: t`Phone Accessories`,
    categoryPk: '02h610t3d001',
  };

  const tablets: CategoryOptionT = {
    value: 'tablets',
    title: t`Tablets`,
    categoryPk: '05t3a2p3p2b0',
  };

  const smartphones: CategoryOptionT = {
    value: 'smartphones',
    title: t`Smartphones`,
    categoryPk: '02h610t3d104',
  };

  const laptops: CategoryOptionT = {
    value: 'laptops',
    title: t`Laptops`,
    categoryPk: '05t394s0h4e1',
  };

  const smartwatches: CategoryOptionT = {
    value: 'smartwatches',
    title: t`Smartwatches`,
    categoryPk: '02h610t3d120',
  };

  return {
    'reebelo-us': [home, gaming, designerBags, sports, tools, fashion],
    'reebelo-ca': [audio, gaming, sports, cameras],
    'reebelo-au': [home, gaming, audio, hairCare, sports, fashion],
    'reebelo-nz': [home, gaming, audio, hairCare, sports],
    'reebelo-uk': [smartphones, laptops, tablets, smartwatches],
    'reebelo-fr': [smartphones, laptops, tablets, smartwatches],
    'reebelo-de': [smartphones, laptops, tablets, smartwatches],
    'reebelo-es': [smartphones, laptops, tablets, smartwatches],
    'reebelo-it': [smartphones, laptops, tablets, smartwatches],
    'reebelo-se': [smartphones, laptops, tablets, smartwatches],
    quista: [audio, tabletAccessories, phoneAccessories],
  } as Partial<Record<ReebeloStoreT, CategoryOptionT[]>>;
};

export { getOptions };
export const CATEGORY_OPTIONS = getOptions();
